import React from 'react'
import { Box, Button, Divider, Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createCompanyCarRppb, createUserCarRppbProject, getCarRppbProjects, getCompanyUserCarRppbs } from '../../../actions/tigercat-burns/tigercat-base-actions';
import AddIcon from '@mui/icons-material/Add';

import AddCarRppbDialog from './dialogs/AddCarRppbDialog';
import AddProjectDialog from './dialogs/AddProjectDialog';
import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';
import BookmarkOutlinedIcon from '@mui/icons-material/BookmarkOutlined';
import BulkFuelDelivery from './main-items/Fuel/BulkFuelDelivery';
import BiocharProductionFuel from './main-items/Fuel/BiocharProductionFuel';
import FeedstockProcessingFuel from './main-items/Fuel/FeedstockProcessingFuel';
import IgnitionFuel from './main-items/Fuel/IgnitionFuel';
import FeedstockTransport from './main-items/Feedstock/FeedstockTransport';
import moment from 'moment';
import { useLocation } from 'react-router-dom';
import BiocharCollection from './main-items/end-use/BiocharCollection';
import BiocharLabSamples from './main-items/lab-tests/BiocharLabSamples';
import BiocharCollectionBins from './main-items/end-use/BiocharCollectionBins';
// BiocharProduction
import BiocharMassBags from './main-items/biochar-production/BiocharMassBags';
import BiocharMassBins from './main-items/biochar-production/BiocharMassBins';
import EquipmentTransport from './main-items/biochar-production/EquipmentTransport';
import BiocharMcBins from './main-items/biochar-production/BiocharMcBins';
import BiocharMcBags from './main-items/biochar-production/BiocharMcBags';
import FeedstockMc from './main-items/Feedstock/FeedstockMc';
import Contaminants from './main-items/lab-tests/Contaminants';
import ProjectDescription from './main-items/project-description/ProjectDescription';
import EligibilityRequirements from './main-items/project-description/EligibilityRequirements';
import MonitoringAndReporting from './main-items/project-description/MonitoringAndReporting';
import RolesAndResponsibilities from './main-items/project-description/RolesAndResponsibilities';
import { DataAccordion } from './shared-components/DataAccordion';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
const CarReporting = () => {
    const dispatch = useDispatch()
    const location = useLocation();
    const [activeCarRppb, setActiveCarRppb] = useState(null);
    const [activeCarRppbProject, setActiveCarRppbProject] = useState(null);
    const [carRppbError, setCarRppbError] = useState({ name: null, start: null, end: null });
    const [projectError, setProjectError] = useState(null)

    // Car Rppb modal    
    const [openCarRppbModal, setOpenCarRppbModal] = useState(false);
    const [reportingEntityName, setReportingEntityName] = useState(null)
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)

    // Project modal
    const [openProjectModal, setOpenProjectModal] = useState(false);
    const [projectName, setProjectName] = useState('')

    // Add bin to project modal
    // const [openAddBinToProjectModal, setOpenAddBinToProjectModal] = useState(false);

    // Add equipment to project modal
    // const [openAddEquipmentToProjectModal, setOpenAddEquipmentToProjectModal] = useState(false);

    const [hide, setHide] = useState(true);
    const [hideProjects, setHideProjects] = useState(true);

    // Main menu items
    const [activeStep, setActiveStep] = useState(null)
    const [activeSubItem, setActiveSubItem] = useState('')

    const carRppbs = useSelector(state => state.tigercatBurnsBaseReducer.carRppbs.data)
    const carRppbProjects = useSelector(state => state.tigercatBurnsBaseReducer.carRppbProjects.data)
    const { userData } = useSelector(state => state.auth);
    const userCompanyId = userData?.tigercatBurnsUser?.companyId;

    const handleSetActiveCarRppb = (carRppb) => {
        setActiveCarRppb(carRppb)
        dispatch(getCarRppbProjects(carRppb.id))
    }
    useEffect(() => {
        if (carRppbs?.length > 0 && !activeCarRppb) {
            const firstCarRppb = carRppbs[0];
            setActiveCarRppb(firstCarRppb);
            dispatch(getCarRppbProjects(firstCarRppb.id));
        }
    }, [carRppbs, activeCarRppb, dispatch]);

    useEffect(() => {
        if (carRppbProjects?.length > 0 && !activeCarRppbProject) {
            setActiveCarRppbProject(carRppbProjects[0]);
        }
    }, [carRppbProjects, activeCarRppbProject]);

    useEffect(() => {
        if (location.state?.carRppb && location.state?.carRppbProject) {
            setActiveCarRppb(location.state.carRppb)
            setActiveCarRppbProject(location.state.carRppbProject)
            setActiveStep(3)
            setActiveSubItem('Feedstock Transport')
        }
    }, [location.state])
    useEffect(() => {
        // Scroll to the bottom of the viewport
        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    }, [activeCarRppb, activeCarRppbProject, activeStep, activeSubItem]);
    useEffect(() => {
        if (userCompanyId)
            dispatch(getCompanyUserCarRppbs(userCompanyId))
    }, [dispatch, userCompanyId])

    const handleSubmitCarRppb = () => {
        setCarRppbError({ name: null, start: null, end: null })
        if (reportingEntityName === null) {
            setCarRppbError((prev) => {
                return {
                    ...prev,
                    name: reportingEntityName === null ? 'Reporting Entity Name is required' : null
                }

            })
        }
        if (startDate === null) {
            setCarRppbError((prev) => {
                return {
                    ...prev,
                    start: startDate === null ? 'Start Date is required' : null,
                }
            })
        }
        if (endDate === null) {
            setCarRppbError((prev) => {
                return {
                    ...prev,
                    end: endDate === null ? 'End Date is required' : null
                }
            })
        }
        if (!reportingEntityName || !startDate || !endDate) return
        setOpenCarRppbModal(false)
        dispatch(createCompanyCarRppb({ reportingEntityName, startDate, endDate }, userCompanyId)).then(() => {
            dispatch(getCompanyUserCarRppbs(userCompanyId))
            setStartDate(null)
            setEndDate(null)
            setReportingEntityName(null)
            setCarRppbError({ name: null, start: null, end: null })
        })
    }

    const handleSubmitProject = () => {
        setProjectError(null)
        if (!projectName) {
            setProjectError('Project Name is required')
            return
        }
        setOpenProjectModal(false)
        dispatch(createUserCarRppbProject(activeCarRppb.id, { projectName })).then(() => {
            dispatch(getCarRppbProjects(activeCarRppb.id))
            setProjectName('')
            setProjectError(null)

        })
    }

    const items = [
        { id: 0, name: 'Project Info', subItems: ['Project Description', 'Eligibility Requirements', 'Monitoring and Reporting', 'Roles and Responsibilities'] },
        { id: 1, name: 'Biochar Production', subItems: ['Equipment Transport', 'Biochar Mass - Bins', 'Biochar Mass - Bags', 'Biochar MC - Bags', 'Biochar MC - Bins'] },
        { id: 2, name: 'Fuel', subItems: ['Bulk Fuel Delivery', 'Biochar Production Fuel', 'Feedstock Processing Fuel', 'Ignition Fuel'] },
        { id: 3, name: 'Feedstock', subItems: ['Feedstock Transport', 'Feedstock MC'] },
        { id: 4, name: 'End Use', subItems: ['Biochar Collection Supersacks', 'Biochar Collection Bins'] },
        { id: 5, name: 'Lab Tests & Factors', subItems: ['C_ORG & H:C', 'Contaminants'] }
    ]

    return (
        <Grid>

            <Box sx={{ background: '#535988', borderRadius: 2, p: 2, mb: 2, display: 'flex' }}>
                <Typography variant='h5' sx={{ fontWeight: 'bold', color: 'whitesmoke' }}>
                    Car Reporting Period Project Bundles
                </Typography>
                <Button
                    className='add-car-btn'
                    variant='outlined'
                    size='medium'
                    sx={{
                        color: "#fff",
                        fontSize: '12px',
                        height: '2.8em',
                        ml: 'auto',
                        float: 'right',
                        border: 'none',
                        '&:hover': {
                            backgroundColor: 'rgba(187, 184, 184, 0.08)', // Change this to your desired hover color
                            border: 'none', // Change this to your desired hover border
                        },
                    }}
                    onClick={() => setOpenCarRppbModal(true)}
                >
                    <AddIcon sx={{ mb: 0.25 }}></AddIcon>Add New CAR Rppb
                </Button>
            </Box>
            <Divider sx={{ my: 2 }} />
            <DataAccordion title="CAR RPPBs" show={!hide} handleChange={() => setHide(!hide)}>
                <Grid item xs={12} display="flex" alignContent={'space-between'} flexWrap={'wrap'} mb={'1rem'}>
                    {carRppbs?.map((carRppb, index) => {
                        return (
                            <Button
                                sx={{ mr: 2 }}
                                key={index}
                                variant={carRppb.id === activeCarRppb?.id ? 'contained' : 'outlined'}
                                color='primary'
                                onClick={() => handleSetActiveCarRppb(carRppb)}>
                                {carRppb.reportingEntityName}
                            </Button>
                        )
                    })}
                </Grid>
            </DataAccordion>
            {
                activeCarRppb &&
                <DataAccordion title="Projects" show={!hideProjects} handleChange={() => setHideProjects(!hideProjects)}>
                    <Grid container>
                        <Box sx={{ display: 'flex' }}>
                            <Typography variant='h5' component='h4' sx={{ mb: 3 }} id="scroll-target-1">
                                CAR RPPB Projects
                            </Typography>
                            <Button
                                variant='outlined'
                                size='medium'
                                sx={{
                                    fontSize: '12px',
                                    height: '2.8em',
                                    float: 'right',
                                    ml: 2,
                                    border: 'none',
                                    '&:hover': {
                                        backgroundColor: 'rgba(187, 184, 184, 0.08)', // Change this to your desired hover color
                                        border: 'none', // Change this to your desired hover border
                                    },
                                }}
                                onClick={() => setOpenProjectModal(true)}
                            ><AddIcon></AddIcon>Add New Project</Button>
                        </Box>
                        <Grid xs={12} display="flex" alignContent={'space-between'} flexWrap={'wrap'} mb={'1rem'}>
                            {carRppbProjects?.map((project, index) => {
                                return (

                                    <Box className="biochar-project" key={index}
                                        sx={activeCarRppbProject?.id === project.id && { background: 'linear-gradient(to bottom right, #535988, #313551)', color: '#FFF', boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px' }}
                                        onClick={() => {
                                            setActiveCarRppbProject(project)
                                            // setProjectId(project.projectId);
                                            // setNickname(project.nickname);
                                            // setProjectKey(project._id)
                                            // setProjectMeasureType(project.measurement_type)
                                        }}>
                                        <Typography sx={{ fontSize: '18px' }}>{activeCarRppbProject?.id === project.id ? <BookmarkOutlinedIcon sx={{ mb: '-7px' }} /> : <BookmarkBorderOutlinedIcon sx={{ mb: '-7px' }} />} {project.id}</Typography>
                                        <Typography sx={project.projectName ? { fontSize: '14px' } : { visibility: 'hidden' }} mt={3}><strong>Project Name:</strong> {project.projectName}</Typography>
                                        <Typography sx={{ fontSize: '14px' }}><strong>Date Created:</strong> {moment(project.createdAt).format('MM-DD-YY')}</Typography>
                                    </Box>
                                )
                            })}
                        </Grid>
                    </Grid>
                </DataAccordion>
            }
            {activeCarRppbProject &&
                <>
                    <Divider sx={{ my: 2 }} />
                    <Grid container>
                        <Grid item xs={6}>
                            <Typography variant='h5' component='h5' sx={{ mb: 1 }}>
                                <strong>Selected Project:</strong> {activeCarRppbProject?.projectName}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Divider sx={{ my: 2 }} />
                    <Grid container>

                        <Grid container spacing={2} xs={12} sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
                            {items.map((item, i) => (
                                <Grid item key={i}>
                                    <Button
                                        variant={activeStep === item.id ? 'contained' : 'outlined'}
                                        onClick={() => { setActiveStep(item.id); setActiveSubItem('') }}
                                    >
                                        {item.name}
                                    </Button>
                                </Grid>
                            ))}
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container spacing={2} justifyContent="flex-start">
                                {activeStep !== null && items[activeStep]?.subItems.map((item, i) => (
                                    <Grid item key={i}>
                                        <Button
                                            startIcon={['Biochar Mass - Bins', 'Biochar Mass - Bags', 'Biochar Collection Supersacks', 'Biochar Collection Bins'].includes(item) ? <PhoneAndroidIcon /> : null}
                                            variant={activeSubItem === item ? 'contained' : 'text'}
                                            onClick={() => setActiveSubItem(item)}
                                        >
                                            {item}
                                        </Button>
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                        <Grid xs={12}>
                            <Divider sx={{ my: 2 }} />
                            {/* Project Description */}
                            {activeStep === 0 && activeSubItem === 'Project Description' ?
                                <ProjectDescription projectId={activeCarRppbProject?.id} /> : null}
                            {activeStep === 0 && activeSubItem === 'Eligibility Requirements' ?
                                <EligibilityRequirements projectId={activeCarRppbProject?.id} /> : null}
                            {activeStep === 0 && activeSubItem === 'Monitoring and Reporting' ?
                                <MonitoringAndReporting projectId={activeCarRppbProject?.id} /> : null}
                            {activeStep === 0 && activeSubItem === 'Roles and Responsibilities' ?
                                <RolesAndResponsibilities projectId={activeCarRppbProject?.id} /> : null}
                            {/* Biochar Data */}
                            {activeStep === 1 && activeSubItem === 'Biochar Mass - Bins' ?
                                <BiocharMassBins project={activeCarRppbProject.projectName} projectId={activeCarRppbProject?.id} /> : null
                            }
                            {activeStep === 1 && activeSubItem === 'Equipment Transport' ?
                                <EquipmentTransport project={activeCarRppbProject.projectName} projectId={activeCarRppbProject?.id} /> : null
                            }
                            {activeStep === 1 && activeSubItem === 'Biochar Mass - Bags' ?
                                <BiocharMassBags project={activeCarRppbProject.projectName} key={activeCarRppbProject?.id} projectId={activeCarRppbProject?.id} /> : null
                            }
                            {activeStep === 1 && activeSubItem === 'Biochar MC - Bags' ?
                                <BiocharMcBags projectId={activeCarRppbProject?.id} /> : null
                            }
                            {activeStep === 1 && activeSubItem === 'Biochar MC - Bins' ?
                                <BiocharMcBins projectId={activeCarRppbProject?.id} /> : null
                            }
                            {/* Fuel */}
                            {activeStep === 2 && activeSubItem === 'Bulk Fuel Delivery' ?
                                <BulkFuelDelivery project={activeCarRppbProject.projectName} projectId={activeCarRppbProject?.id} /> : null
                            }
                            {activeStep === 2 && activeSubItem === 'Biochar Production Fuel' ?
                                <BiocharProductionFuel project={activeCarRppbProject.projectName} projectId={activeCarRppbProject?.id} /> : null
                            }
                            {activeStep === 2 && activeSubItem === 'Feedstock Processing Fuel' ?
                                <FeedstockProcessingFuel project={activeCarRppbProject.projectName} projectId={activeCarRppbProject?.id} /> : null
                            }
                            {activeStep === 2 && activeSubItem === 'Ignition Fuel' ?
                                <IgnitionFuel project={activeCarRppbProject.projectName} projectId={activeCarRppbProject?.id} /> : null
                            }
                            {/* Feedstock */}
                            {activeStep === 3 && activeSubItem === 'Feedstock Transport' ?
                                <FeedstockTransport project={activeCarRppbProject.projectName} projectId={activeCarRppbProject?.id} /> : null
                            }
                            {activeStep === 3 && activeSubItem === 'Feedstock MC' ?
                                <FeedstockMc project={activeCarRppbProject.projectName} projectId={activeCarRppbProject?.id} /> : null
                            }
                            {/* End Use */}
                            {activeStep === 4 && activeSubItem === 'Biochar Collection Supersacks' ?
                                <BiocharCollection project={activeCarRppbProject.projectName} projectId={activeCarRppbProject?.id} /> : null
                            }
                            {activeStep === 4 && activeSubItem === 'Biochar Collection Bins' ?
                                <BiocharCollectionBins project={activeCarRppbProject.projectName} projectId={activeCarRppbProject?.id} /> : null
                            }
                            {/* Lab Tests & Factors */}
                            {activeStep === 5 && activeSubItem === 'C_ORG & H:C' ?
                                <BiocharLabSamples project={activeCarRppbProject.projectName} projectId={activeCarRppbProject?.id} /> : null
                            }
                            {activeStep === 5 && activeSubItem === 'Contaminants' ?
                                <Contaminants project={activeCarRppbProject.projectName} projectId={activeCarRppbProject?.id} /> : null
                            }
                        </Grid>
                    </Grid>
                </>
            }
            <AddCarRppbDialog
                carRppbError={carRppbError}
                setCarRppbError={setCarRppbError}
                openCarRppbModal={openCarRppbModal}
                setOpenCarRppbModal={setOpenCarRppbModal}
                reportingEntityName={reportingEntityName}
                setReportingEntityName={setReportingEntityName}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                handleSubmitCarRppb={handleSubmitCarRppb}
            />
            <AddProjectDialog
                projectError={projectError}
                setProjectError={setProjectError}
                openProjectModal={openProjectModal}
                setOpenProjectModal={setOpenProjectModal}
                projectName={projectName}
                setProjectName={setProjectName}
                handleSubmitProject={handleSubmitProject}
            />
        </Grid >
    )
}

export default CarReporting